export default __webpack_public_path__ + "static/SGCC_Classroom1-dc766f041c854d9b69ae8d30f0670919.jpg";